// Legal section configuration
// Defines fields, validation, and metadata for the legal step
import { z } from 'zod';
import type { SectionConfig } from '../../types/sections';

// Validation schema for legal section
export const legalSectionSchema = z.object({
  commercialName: z.string().min(1, 'El nombre comercial es requerido'),
  legalConstitution: z.string().min(1, 'La constitución legal es requerida'),
  legalName: z.string().min(1, 'El nombre legal es requerido'),
  originCountries: z.array(z.string()).min(1, 'Al menos un país es requerido'),
  operationsStartYear: z.string().min(1, 'El año de inicio es requerido'),
});

export type LegalSectionData = z.infer<typeof legalSectionSchema>;

// Section config
export const legalSection: SectionConfig = {
  id: 'legal',
  titleKey: 'Datos legales de la StartUp',
  descriptionKey: 'Información legal y de constitución de tu empresa',
  validationSchema: legalSectionSchema,
  fields: [
    {
      name: 'commercialName',
      type: 'text',
      label: 'Nombre comercial de la Startup / PyMe',
      placeholder: 'Ingresa el nombre comercial',
      required: true,
    },
    {
      name: 'legalConstitution',
      type: 'radio',
      label: 'Constitución legal',
      required: true,
      helpText:
        'Indica si la empresa se encuentra constituida como una sociedad separada del patrimonio de sus socios o fundadores',
      options: [
        { value: 'origin_country', label: 'Sí, en país de origen de la empresa' },
        { value: 'delaware_cayman', label: 'Sí, en Delaware o Cayman Sandwich' },
        { value: 'no', label: 'No' },
      ],
    },
    {
      name: 'legalName',
      type: 'text',
      label: 'Nombre legal de la Startup / PyMe',
      placeholder: 'Ingresa el nombre legal registrado',
      required: true,
      helpText: 'Escribe la razón social de tu compañía como está registrada legalmente',
    },
    {
      name: 'originCountries',
      type: 'multiselectDropdown',
      label: 'País de origen',
      required: true,
      options: [
        { value: 'CR', label: 'Costa Rica' },
        { value: 'CO', label: 'Colombia' },
        { value: 'MX', label: 'México' },
        { value: 'PA', label: 'Panamá' },
        { value: 'GT', label: 'Guatemala' },
        { value: 'SV', label: 'El Salvador' },
        { value: 'HN', label: 'Honduras' },
        { value: 'NI', label: 'Nicaragua' },
        { value: 'US', label: 'Estados Unidos' },
      ],
    },
    {
      name: 'operationsStartYear',
      type: 'date',
      label: 'Año de inicio de operaciones',
      required: true,
    },
  ],
};
